/* esm.sh - applesauce-common@5.2.0/dist/operations/gift-wrap */
export * from "/*applesauce-common@5.2.0/esnext/dist/operations/gift-wrap.mjs";
